import React from "react";
import "../OpalAccountInfoDetails.css";

const OpalAccountBasicInfo = ({ data }) => {
    return (
        <div className="opal-info-details">
            <div className="opal-row">
                <div className="opal-cell label">Code</div>
                <div className="opal-cell value">{data?.code}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Name</div>
                <div className="opal-cell value">{data?.name}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Institution</div>
                <div className="opal-cell value">{data?.institution?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Mobile Number</div>
                <div className="opal-cell value">{data?.mobileNumber}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Email</div>
                <div className="opal-cell value">{data?.email}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Title</div>
                <div className="opal-cell value">{data?.title}</div>
            </div>
        </div>
    );
};

export default OpalAccountBasicInfo;
